import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column, Row } from "simple-flexbox";
import CheckIcon from "@material-ui/icons/Check";
import { StyleSheet, css } from "aphrodite";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import {
  renderSelectWithLabel,
  renderDatepickerWithLabel,
  renderInputWithLabel,
  renderFileForm,
} from "../../../components/form/FormComponent";
import {
  listActivity,
  detailActivity,
} from "../../../actions/master-data/activity_action";
import {
  getActivityPending,
  getDetailActivity,
} from "../../../reducers/master-data/activity_reducer";
import { uploadP2kb } from "../../../actions/p2kb/p2kb_action";
import {
  getP2kbUploadPending,
  getP2kbUpload
} from "../../../reducers/p2kb/p2kb_reducer";
import DetailContentLihatBerkas from "../../../components/detail/DetailContentLihatBerkas";
import ModalDocument from "../../../components/modal/ModalDocument";

import Loading from "../../../components/global-components/LoadingComponent";

class KajianIlmiahModalAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDocument: false,
      berkas: null,
      berkas_disabled: false,
      isDoneUploading: true,
      filename: "",
      spek_berkas: null
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeValues = this.handleChangeValues.bind(this);
    this.handleChangeLastActivity = this.handleChangeLastActivity.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { reset, show } = this.props;
    if (prevProps.show !== show && show === true) {
      reset();
    }
  }

  handleChangeLastActivity(values) {
    const { change } = this.props;
    change("values_id", null);
  }

  handleChangeValues(values) {
    if (values) {
      const { skp_must_be_multipied, value_multipied, value_skp } = values;

      if (skp_must_be_multipied === 0) {
        this.props.change("skp_total", value_skp);
      } else {
        this.props.change("skp_total", Math.round(value_skp * value_multipied));
      }
    } else {
      this.props.change("skp_total", null);
    }
  }

  handleOpenDocument(filename, modalTitle) {
    this.setState({
      filename: filename,
      modalTitle: modalTitle,
      showDocument: true,
    });
  }

  handleUploadFile(values) {
    const formName = values.target.name;
    this.setState({
      isDoneUploading: false,
      berkas_disabled: true,
      [formName]: <Loading />,
    });

    const callback = () => {
      this.setState({ isDoneUploading: true, berkas_disabled: false });
      if (this.props.uploadP2kb_data) {
        this.props.change(formName, this.props.uploadP2kb_data);
        this.setState({ berkas: <Loading done={true} /> });
        setTimeout(
          () =>
            this.setState({
              [formName]: (
                <DetailContentLihatBerkas
                  onClick={() =>
                    this.handleOpenDocument(
                      this.props.formValue.berkas,
                      "Daftar Hadir"
                    )
                  }
                />
              ),
            }),
          2000
        );
      }
    };
    const error = () => {
      this.setState({ isDoneUploading: true, berkas_disabled: false });
      if (this.props.uploadP2kb_error) {
        this.props.change([formName], null);
        this.setState({
          [formName]: <Loading done={true} failed={true} />,
        });
      }
    };
    this.props.uploadP2kb(values.target.files[0], callback, error);
    this.props.change("spek_berkas", values.target.files[0]);
  }

  handleSubmit(values) {
    this.props.handleAddSkp(values);
    this.props.onHide();
  }

  render() {
    const {
      show,
      onHide,
      handleSubmit,
      uploadP2kb_pending,
      formValue: { last_activity },
      detailActivity_data,
    } = this.props;
    const { berkas, showDocument, filename, modalTitle } = this.state;

    let lastActivityOptions = [];
    let valuesOptions = [];
    if (detailActivity_data && detailActivity_data.lenght !== 0) {
      lastActivityOptions = detailActivity_data[0].childrens.map(
        ({ id, values, name }) => ({ value: id, label: name, values: values })
      );
    }
    if (last_activity) {
      valuesOptions = last_activity.values.map((item) => ({
        ...item,
        value: item.id,
      }));
    }
    return (
      <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalDocument
          show={showDocument}
          onHide={() => this.setState({ showDocument: false })}
          filepath="member_p2kb"
          filename={filename}
          modalTitle={modalTitle}
        />
        <Modal.Header closeButton>
          <p style={{ fontSize: 20, fontWeight: 600 }}>Tambah SKP</p>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={handleSubmit(this.handleSubmit)}
            style={{ width: "100%" }}
          >
            <Column
              vertical="center"
              horizontal="stretch"
              className={css(styles.bodyModal)}
            >
              <>
                <Field
                  name="activity_date"
                  placeholder="Masukkan tanggal kegiatan"
                  label="Tanggal Kegiatan"
                  component={renderDatepickerWithLabel}
                />
                <Field
                  name="theme"
                  placeholder="Masukkan tema kegiatan"
                  label="Tema Kegiatan"
                  component={renderInputWithLabel}
                />
                <Field
                  name="last_activity"
                  placeholder="Pilih tingkat"
                  label="Tingkat"
                  options={lastActivityOptions}
                  onChange={this.handleChangeLastActivity}
                  component={renderSelectWithLabel}
                />

                <Field
                  name="values_id"
                  placeholder="Pilih status"
                  label="Status"
                  options={valuesOptions}
                  onChange={this.handleChangeValues}
                  component={renderSelectWithLabel}
                />
                <Field
                  name="skp_total"
                  placeholder="Jumlah SKP"
                  label="Jumlah SKP"
                  disable={true}
                  component={renderInputWithLabel}
                />
                <Field
                  name="berkas"
                  fileType="skp"
                  title="daftar hadir"
                  disabled={this.state.berkas_disabled}
                  isDone={this.state.isDoneUploading}
                  message={berkas ? berkas : "PDF, PNG, JPG maksimal 1 MB"}
                  onChange={this.handleUploadFile}
                  component={renderFileForm}
                />
              </>
            </Column>
            <Row
              horizontal="flex-end"
              vertical="center"
              className={css(styles.footerModal)}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={uploadP2kb_pending}
                className={css(styles.approveButton)}
                startIcon={<CheckIcon />}
              >
                simpan
              </Button>
            </Row>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  approveButton: {
    background: "#2CB96A 0% 0% no-repeat padding-box",
    boxShadow: "none",
  },
  rejectButton: {
    background: "#EAEBED 0% 0% no-repeat padding-box",
    marginRight: 10,
    color: "#495057",
    boxShadow: "none",
  },
  footerModal: {
    backgroundColor: "#FBFBFD",
    padding: "20px 40px",
  },
  bodyModal: {
    padding: "0px 40px 20px",
    width: "100%",
  },
});

function validate(values) {
  const maxFileSize = 1000000; //1MB
  const typeImage = /image/
  const fileType = "application/pdf"
  const { activity_date, last_activity, values_id, theme, berkas, spek_berkas } = values;
  const errors = {};
  if (!activity_date) {
    errors.activity_date = "Tanggal kegiatan wajib diisi";
  }
  if (!last_activity) {
    errors.last_activity = "Tingkat kegiatan wajib diisi";
  }
  if (!theme) {
    errors.theme = "Tema kegiatan wajib diisi";
  }
  if (!values_id) {
    errors.values_id = "Status kegiatan wajib diisi";
  }

  if (!berkas) {
    errors.berkas = "Berkas daftar hadir wajib diisi";
  }
  else{
    if (spek_berkas && (!spek_berkas.type.match(typeImage) && spek_berkas.type !== fileType)){
      errors.berkas = "Format file hanya bisa Image atau PDF"
    }
    else if (spek_berkas && (spek_berkas.size > maxFileSize)){
      errors.berkas = "File lebih dari 1 MB"
    }
  }
  return errors;
}

KajianIlmiahModalAdd = reduxForm({
  form: "KajianIlmiahModalAdd",
  validate: validate,
  shouldError: () => true,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(KajianIlmiahModalAdd);

function mapStateToProps(state) {
  const { listActivity, uploadP2kb, detailActivity } = state;
  const selector = formValueSelector("KajianIlmiahModalAdd");
  const formValue = selector(state, "last_activity", "berkas", "spek_berkas");

  return {
    listActivity_pending: getActivityPending(listActivity),
    detailActivity_data: getDetailActivity(detailActivity),
    uploadP2kb_pending: getP2kbUploadPending(uploadP2kb),
    uploadP2kb_data: getP2kbUpload(uploadP2kb),
    formValue,
  };
}

export default connect(mapStateToProps, {
  listActivity,
  detailActivity,
  uploadP2kb,
})(withRouter(KajianIlmiahModalAdd));
